import { APP_CONFIG } from "@/data/constants";

/**
 * PG·본인인증(다날 등) 심사용 사업자 정보.
 * Vercel/로컬 환경변수로 설정하세요.
 */
export const BUSINESS_INFO = {
  companyName:
    process.env.NEXT_PUBLIC_COMPANY_NAME || "하와플래닛",
  businessNumber:
    process.env.NEXT_PUBLIC_BUSINESS_NUMBER || "854-22-02085",
  ceoName: process.env.NEXT_PUBLIC_CEO_NAME || "조한결",
  address:
    process.env.NEXT_PUBLIC_BUSINESS_ADDRESS ||
    "인천광역시 연수구 송도미래로 30, E801호(송도 BRC 스마트밸리)",
  phone: process.env.NEXT_PUBLIC_BUSINESS_PHONE || "010-7595-3003",
  email:
    process.env.NEXT_PUBLIC_BUSINESS_EMAIL || APP_CONFIG.SUPPORT_EMAIL,
  /** 통신판매업신고번호 (예: 2026-인천연수구-0000) */
  mailOrderNumber:
    process.env.NEXT_PUBLIC_MAIL_ORDER_NUMBER || "2026-인천연수구-2102호",
} as const;

export function formatBusinessNumber(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }
  if (digits.length === 12) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value;
}

export function isBusinessInfoComplete(): boolean {
  return Boolean(
    BUSINESS_INFO.companyName &&
      BUSINESS_INFO.businessNumber &&
      BUSINESS_INFO.ceoName &&
      BUSINESS_INFO.address &&
      BUSINESS_INFO.email
  );
}
